import types from "./types";
import {createError, logError, logSuccess} from "./message";
import api from "../api";
import {getRequestMessages} from "./actions";

function requestCreateRequestMessage() {
  return {
    type: types.SEND_REQUEST_MESSAGE_REQUEST,
    isCreatingMessage: true
  };
}

function requestCreateRequestMessageCompleted(createdMessage) {
  return {
    type: types.SEND_REQUEST_MESSAGE_COMPLETE,
    isCreatingMessage: false,
    createdMessage
  };
}

function requestCreateRequestMessageError(createMessageError) {
  return {
    type: types.SEND_REQUEST_MESSAGE_ERROR,
    isCreatingMessage: false,
    createMessageError
  };
}

export function createRequestMessage(requestId, token, data) {
  return dispatch => {
    dispatch(requestCreateRequestMessage());
    return api.createRequestMessage(requestId, token, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestCreateRequestMessageCompleted(response.data));
          dispatch(getRequestMessages(requestId, token));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestCreateRequestMessageError(message));
        } else {
          logError(err);
          dispatch(requestCreateRequestMessageError(createError("Не удалось отправить сообщение")));
        }
      });
  };
}

export default {
  createRequestMessage
};
